import React from 'react';

import { Title, Button } from 'components/commons';
import trafficIcon from 'assets/svg/traffic-signal.svg';

type RequestDeniedInQueueLayoutProps = {
    onOk(): void;
}

const RequestDeniedInQueueLayout: React.FC<RequestDeniedInQueueLayoutProps> = ({ onOk }) => (
    <div className="message-box-container denied-container">
        <div className="inner">
            <div className="screen">
                <div className="message-box">
                    <img className="icon" src={trafficIcon} />

                    <Title>colocamos seu nome na lista de espera</Title>

                    <p className="text">
                        Nossa rotina também está mudando por conta do novo <br className="d-block d-sm-none" />
                        coronavírus, e por isso estamos recebendo um grande <br className="d-block d-sm-none" />
                        número de pedidos, sobrecarregando nossos sistemas e <br className="d-block d-sm-none" />
                        nossa operação.
                    </p>

                    <p className="text bold">
                        enviamos um email com a explicação detalhada. <br className="d-block d-sm-none" />
                        pedimos desculpas pelo período conturbado.
                    </p>
                </div>

                <Button className="mt-4" label="concluir" onClick={onOk} />
            </div>
        </div>
    </div>
);

export default RequestDeniedInQueueLayout;
